exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog_bodyInner.dialog_changeLandscape .dialog_cont .dialog_message {\n  padding: 10px 0;\n  font-weight: bold; }\n", ""]);

// exports
